
import React from 'react';
import Lightbox from 'react-images';

const photos = [
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362108/PVQW/F499A20F-.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362109/PVQW/IMG950233.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362108/PVQW/IMG950234.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362109/PVQW/33F53665-.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362109/PVQW/9E503C31-.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362110/PVQW/IMG950410.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362110/PVQW/IMG950447.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362109/PVQW/IMG950458.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362109/PVQW/IMG950462.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362107/PVQW/IMG950261.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362108/PVQW/IMG950262.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362110/PVQW/IMG950288_01.jpg', width: 1, height: 1},
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362109/PVQW/6F48D5EE-.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362108/PVQW/IMG950270.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362108/PVQW/IMG950272_01.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362108/PVQW/15340AFA-.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362108/PVQW/A9A81B89-.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362110/PVQW/IMG950341.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362110/PVQW/IMG950402.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362109/PVQW/IMG950404.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362108/PVQW/IMG950413.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362108/PVQW/IMG950425.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362110/PVQW/IMG950428.jpg', width: 1, height: 1 },
    { src: 'https://res.cloudinary.com/dmcxpmuqw/image/upload/v1525362108/PVQW/IMG950433.jpg', width: 1, height: 1 },  
];
class Gallery extends React.Component {
    constructor() {
        super();
        this.state = {currentImage: 0};
        this.closeLightbox = this.closeLightbox.bind(this);
        this.openLightbox = this.openLightbox.bind(this);
        this.gotoNext = this.gotoNext.bind(this);
        this.gotoPrevious = this.gotoPrevious.bind(this);
    }

    componentDidMount() {
        this.openLightbox();
    }

    openLightbox(event, obj) {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: true,
        });

    }

    closeLightbox() {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
        this.props.history.push("/")
    }

    gotoPrevious() {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    }

    gotoNext() {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    }
    
    render() {
        return (
            <Lightbox
                images={photos}
                onClose={this.closeLightbox}
                onClickPrev={this.gotoPrevious}
                onClickNext={this.gotoNext}
                currentImage={this.state.currentImage}
                isOpen={this.state.lightboxIsOpen}
            />
        )
    }
}

export default Gallery;








// WEBPACK FOOTER //
// ./src/components/Gallery.js